module.exports = __webpack_public_path__ + "img/about_zhTc.e925f4cf.png";